import InnerComponent from '@Components/Purchase/GoodsReceiving/GoodsReceivingHome/ViewSTGRN';
import orgContainer from '@Components/AppContainer';

const ViewStGrnPage = () => ((orgContainer(InnerComponent)));
export default ViewStGrnPage;
